import type { AdminActingSession, RoleClaim, UserProfile } from "@/types/clm-web";
import { hasRole } from "./role-access";

const BLOCKED_TARGET_ROLES: readonly RoleClaim[] = ["owner", "super_admin"];

export interface BlockedActingSessionInput {
  actualUser: UserProfile;
  targetUser: UserProfile;
  actualUserRoles: RoleClaim[];
  targetUserRoles: RoleClaim[];
  reason: string;
}

export function canStartActingAs(
  actualUserRoles: readonly RoleClaim[],
  targetUserRoles: readonly RoleClaim[],
): boolean {
  if (!hasRole("admin", actualUserRoles)) {
    return false;
  }

  if (hasRole("owner", actualUserRoles)) {
    return true;
  }

  return !targetUserRoles.some((role) => BLOCKED_TARGET_ROLES.includes(role));
}

export function createBlockedActingSession(input: BlockedActingSessionInput): AdminActingSession {
  const timestamp = new Date().toISOString();

  return {
    actingSessionId: `blocked-${input.targetUser.personId ?? input.targetUser.email}`,
    actualUser: input.actualUser,
    effectiveUser: input.targetUser,
    actualUserRoles: input.actualUserRoles,
    effectiveUserRoles: input.targetUserRoles,
    startedAt: timestamp,
    startedFromRoute: "/admin/people",
    returnRoute: "/admin/people",
    auditCorrelationId: `blocked-${timestamp}`,
    status: "blocked",
  };
}

export function isActingAsActive(actingSession: AdminActingSession | undefined): boolean {
  return Boolean(
    actingSession &&
    actingSession.status === "active" &&
    actingSession.actualUser.email &&
    actingSession.effectiveUser.email,
  );
}
